import {LeafletVectorSource} from '../classes/leaflet-vector-source';
import {LeafletMapLayer} from '../classes/leaflet-map-layer';
import {LeafletFeature} from '../classes/leaflet-feature';
import L from 'leaflet';
import {LayerStyleService} from '../services/layer-style.service';
import {Feature} from 'geojson';

export class SafetyZonesSource extends LeafletVectorSource {
    constructor(layerInfo: LeafletMapLayer) {
        super(layerInfo);
    }

    processFeatures(features: Feature[]) {
        const leafletFeatures = features
            .map((v) => new LeafletFeature<Feature>(v).buildPopover(this.layerInfo))
            .sort((a, b) => {
                if (a.getGeometryType() > b.getGeometryType()) return -1;
                else if (a.getGeometryType() < b.getGeometryType()) return 1;
                return 0;
            });

        const style = (feature: any, latlng: L.LatLng): L.Layer => {
            return L.marker(latlng, {
                icon: getStyle(),
            });
        };

        const config: any = {
            pointToLayer: style,
            onEachFeature: this.initializePopoverInteractions.bind(this),
            features: leafletFeatures,
        };

        this.source = L.geoJSON(leafletFeatures as any, config);
    }
}

function getStyle(): any {
    const key = 'safetyZones';
    let style = LayerStyleService.layerStyles.get(key);
    if (!style) {
        const color = '#CA7BF5';
        const options = {
            icon: 'circle',
            backgroundColor: color,
            borderColor: color,
            innerIconStyle: `color:${color}; position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); margin-top: 0px;`,
            iconSize: [10, 10],
        };

        style = (L as any).BeautifyIcon.icon(options);

        LayerStyleService.layerStyles.set(key, style);
    }
    return style;
}
